import { Grid, MenuItem, TextField } from '@mui/material'
import React from 'react'
import { FormField } from '../../../forms'

export function CreateAlertInfo(): React.JSX.Element {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormField
          fullWidth
          label='Alert Summary'
          name='summary'
          required
          component={TextField}
        />
      </Grid>
      <Grid item xs={12}>
        <FormField
          fullWidth
          select
          label='Severity'
          name='severity'
          required
          component={TextField}
        >
          <MenuItem value='CRITICAL'>Critical</MenuItem>
          <MenuItem value='HIGH'>High</MenuItem>
          <MenuItem value='MEDIUM'>Medium</MenuItem>
          <MenuItem value='LOW'>Low</MenuItem>
        </FormField>
      </Grid>
      <Grid item xs={12}>
        <FormField
          fullWidth
          multiline
          rows={7}
          placeholder='Alert Details'
          name='details'
          component={TextField}
        />
      </Grid>
    </Grid>
  )
}
